import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


//import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyABXGSJzZKA2SRIkaznvLtSAnFPYN2981s",
  authDomain: "lovaue-be273.firebaseapp.com",
  databaseURL: "https://lovaue-be273-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "lovaue-be273",
  storageBucket: "lovaue-be273.appspot.com",
  messagingSenderId: "959233473118",
  appId: "1:959233473118:web:f130a715b98542c1cbd2cf",
  measurementId: "G-EPG4TV1QJK"
};

const firebaseApp = initializeApp(firebaseConfig);
//const analytics = getAnalytics(firebaseApp);

// utils
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

export {
  db,
  auth
}


